<template>
	<div>
		<v-dialog v-model="dialog_ledger" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">Add Ledger</v-toolbar-title>

				    <v-spacer></v-spacer>

				    <!-- <v-btn round-borders outline :disabled="disableBtn" @click="fn_checkValidations">Done</v-btn> -->
					<!-- <v-btn icon dark-opacity-color flat @click="$parent.fn_removeItem(null)" v-if="$parent.Form.ledgerDataModel.groupId"><v-icon class="redcolor">delete</v-icon></v-btn> -->

				</v-toolbar>
        		
        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width class="hasBigFooter">
        	  			<v-layout wrap padding-top-bottom-ten white-background>

							<v-flex xs12 sm12 md12 align-msg-right form-item
					        	@click="fn_openLedgers">

				               <v-text-field  
					               	readonly
					               	v-model="$parent.Form.ledgerDataModel.accountName" 
					               	label="Select Ledger" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	:onUpdate="fn_updateLedger"
					               	ref="ref_dialogLedger_ledgerName"
					               	v-validate="'required'" 
				               		data-vv-name="ledger" 
				               		:error-messages="errors.collect('fields.ledger')"
				               		required>
				               </v-text-field>
				            </v-flex>

						</v-layout>

						<v-layout margin-top-ten row wrap padding-top-ten white-background>

							<v-flex xs12 sm12 md12 form-item>
					           	<v-text-field 
								   	:disabled="disableBtn"
					           		v-model.number="$parent.Form.ledgerDataModel.amount"
					           		label="Amount"
					           		placeholder=" "
					           		type="number"
					           		v-validate="'min_value:0|decimal:2'" 
				               		data-vv-name="amount" 
				               		:error-messages="errors.collect('fields.amount')">
					           	</v-text-field>
					        </v-flex>

						</v-layout>

						<div class="pt-2 pb-2 grey-back full-width" v-if="$parent.settings.transactionTypeId != 20001">

							<template v-if="hasSeries && !hasOnlySeries && $root.TransactionSettings.enableBatch">
								<v-radio-group class="pt-3 pl-3 pr-3 pb-1" white-background hide-details v-model="$parent.Form.selectedBatchType" row @change="fn_changeBatchType($event)">
									<v-radio label="Batch" :value="1"></v-radio>
									<v-radio label="Series" :value="2"></v-radio>
								</v-radio-group>
								<v-divider></v-divider>
							</template>



						</div>

				        <v-layout row wrap padding-top-ten white-background v-if="$parent.Form.taxMode">

				        	<v-layout row wrap>
				        		<v-flex xs12 sm12 md12 form-item @click="openTaxCategories">
				        			<v-text-field  
						               	readonly
						               	v-model="$parent.Form.ledgerDataModel.taxCategoryName" 
						               	label="Tax Category" 
						               	placeholder=" " 
						               	append-icon="arrow_drop_down">
					               </v-text-field>
				        		</v-flex>
				        	</v-layout>

				        	<v-layout row wrap>

				        		<v-flex xs6 sm6 md6 pr-2 pl-3>
						           	<v-text-field 
						           		:disabled="true"
										suffix="%"
						           		v-model="$parent.Form.ledgerDataModel.taxValue"
						           		label="GST" 
						           		placeholder=" ">
						           	</v-text-field>
						        </v-flex>

						        <v-flex xs6 sm6 md6 pr-3 pl-2>
						           	<v-text-field 
						           		:disabled="true"
						           		v-model="$parent.Form.ledgerDataModel.taxAmount"
						           		label="" 
						           		prefix="₹"
						           		placeholder=" ">
						           	</v-text-field>
						        </v-flex>   

				        	</v-layout>

				        	<!-- v-if="$parent.Form.ledgerDataModel.cessValue" -->
				        	<v-layout row wrap v-if="$parent.Form.ledgerDataModel.isCessApplicable">

				        		<v-flex xs6 sm6 md6 pr-2 pl-3>
						           	<v-text-field 
						           		:disabled="true"
						           		v-model="$parent.Form.ledgerDataModel.cessValue"
						           		label="Cess" 
										suffix="%"  
						           		placeholder=" ">
						           	</v-text-field>
						        </v-flex>

						        <v-flex xs6 sm6 md6 pr-3 pl-2>
						           	<v-text-field 
									   	:disabled="true"
						           		@input="$parent.Form.ledgerDataModel.cessValue = null"
						           		type="number"
						           		v-model.number="$parent.Form.ledgerDataModel.cessAmount"
						           		label="" 
						           		prefix="₹"
						           		placeholder=" "
						           		v-validate="'min_value:0|decimal:2'" 
					               		data-vv-name="cessAmount" 
					               		data-vv-as="cess amount" 
					               		:error-messages="errors.collect('fields.cessAmount')">
						           	</v-text-field>
						        </v-flex>   

				        	</v-layout>

					        <v-flex xs12 sm12 md12 form-item v-if="$root.CurrentBusiness.GSTRegistrationStatus==1 && $root.CurrentBusiness.HSNApplicable">
					           	<v-text-field 
								   :disabled="disableBtn"
					           		v-model="$parent.Form.ledgerDataModel.hsnCode"
					           		label="HSN" 
					           		placeholder=" "
					           		v-validate="'verify_hsn'" 
				               		data-vv-name="hsn" 
				               		:error-messages="errors.collect('fields.hsn')">
					           	</v-text-field>
					        </v-flex>

				        </v-layout>

						<v-list white-background full-width nopadding v-if="netAmount">
							<v-list-tile>
								<v-list-tile-content>
									<v-list-tile-title>Item Total</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
									&#8377; {{$root.numberToLocale(netAmount)}}
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
						
        	  		</v-form>
        	  		
        	  	</v-card-text>

				<div white-background full-width nopadding style="position:fixed;bottom:0;">
					<v-layout row wrap style="background:#ddd;">
						<v-flex xs12 sm12 md12>
							<v-btn style="height:48px !important" color="primary" nomargin block no-round-borders noshadow :disabled="disableBtn" @click="fn_checkValidations(false)">Done</v-btn>
						</v-flex>
					</v-layout>
				</div>

	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>
// const menuItem = require('../../../../../config.js').configs.menuItem;
const transactionTypes = require('../../../../../config.js').configs.transactionTypes;

export default{
	props:['openProducts', 'openTaxCategories', 'saveItem'],
	data(){	
		return{
			dialog_ledger: false,
			summaryArray:[],
			disableBtn:false,
			hasOnlySeries:true,
			hasSeries:false,
			seriesFields:[],
			dialogJustOpen:true
			// tempRate:null
		}
	},
	methods:{
		openDialogWeb: function () {
			this.$validator.reset();
			this.dialog_ledger = true;
			// this.dialogJustOpen = true;
			// setTimeout(() => {
			// 	this.dialogJustOpen = false;
			// }, 500);
		},
		closeDialogWeb: function () {
			this.dialog_ledger = false;
		},
		
		fn_openLedgers: function () {
			this.$parent.fn_openAccountLedgers('android', 'Ledger', 'ref_dialogLedger_ledgerName', this.$parent.Form.ledgerDataModel.accountId, this.$parent.Form.ledgerDataModel.accountName);
		},

		fn_updateProduct: function (selectedValueId, selectedValueName, isRemoved) {
			if(!isRemoved){
				this.$parent.Form.ledgerDataModel.productId = selectedValueId;
	        	this.$parent.Form.ledgerDataModel.productName = selectedValueName;
	        	this.$forceUpdate();
	        	this.errors.remove('fields.item');
	        	// this.fn_getItem(selectedValueId)
	        	this.fn_getProductData(false, selectedValueId);

				if(this.$parent.Form.ledgerDataModel && this.$parent.Form.ledgerDataModel.productVariants && this.$parent.Form.ledgerDataModel.productVariants.length && !this.$parent.Form.ledgerDataModel.productVariants[0].secondaryUnitId){
					this.$parent.Form.ledgerDataModel.productVariants[0].selectedUnit = null;
				}
	        	// this.fn_getSummary(selectedValueId);
			}
			else{
				this.$parent.Form.ledgerDataModel.productId = null;
	        	this.$parent.Form.ledgerDataModel.productName = null;
			}
		},

        fn_updateLedger: function (selectedValueId, selectedValueName, isRemoved) {
			if(!isRemoved){
				this.$parent.Form.ledgerDataModel.accountId = selectedValueId;
	        	this.$parent.Form.ledgerDataModel.accountName = selectedValueName;
	        	this.$forceUpdate();
	        	this.errors.remove('fields.ledger');
	        	// this.fn_getProductData(false, selectedValueId);
			}
			else{
				this.$parent.Form.ledgerDataModel.accountId = null;
	        	this.$parent.Form.ledgerDataModel.accountName = null;
			}
		},
		
		fn_getProductData: function (refreshUnits, itemId, baseTransactionListId) {
			let self = this;
			this.getData('Product', itemId, 
				{
					onSuccess: function(response){
			          console.log(response);
			          let productData = JSON.parse(response);
			          self.fn_getSummary(productData.productId);

			          if(refreshUnits){
			          	self.fn_refreshUnits(productData.productVariants, baseTransactionListId);

						//   if(productData.productVariants[0].secondaryUnitId){
						// 		self.$parent.Form.ledgerDataModel.productVariants[0].unitId = productData.productVariants[0].unitId;
						// 		self.$parent.Form.ledgerDataModel.productVariants[0].unitName = productData.productVariants[0].unitName;

						// 		self.$parent.Form.ledgerDataModel.productVariants[0].secondaryUnitId = productData.productVariants[0].secondaryUnitId;
						// 		self.$parent.Form.ledgerDataModel.productVariants[0].secondaryUnitName = productData.productVariants[0].secondaryUnitName;

						// 		self.$parent.Form.ledgerDataModel.productVariants[0].secondaryUnitPackQuantity = productData.productVariants[0].secondaryUnitPackQuantity;
						// 	}

						// if(!self.$parent.Form.ledgerDataModel.productVariants[0].unitId){
						// 	self.$parent.Form.ledgerDataModel.productVariants[0].unitId = productData.productVariants[0].unitId;
						// 	self.$parent.Form.ledgerDataModel.productVariants[0].unitName = productData.productVariants[0].unitName;
						// 	self.$parent.Form.ledgerDataModel.productVariants[0].packQuantity = productData.productVariants[0].packQuantity;
						// }
						// else{
						// 	if(self.$parent.Form.ledgerDataModel.productVariants[0].primaryUnitId && self.$parent.Form.ledgerDataModel.productVariants[0].primaryUnitName){
						// 		self.$parent.Form.ledgerDataModel.productVariants[0].unitId = self.$parent.Form.ledgerDataModel.productVariants[0].unitId;
						// 		self.$parent.Form.ledgerDataModel.productVariants[0].unitName = self.$parent.Form.ledgerDataModel.productVariants[0].unitName;
						// 		self.$parent.Form.ledgerDataModel.productVariants[0].packQuantity = self.$parent.Form.ledgerDataModel.productVariants[0].packQuantity;
						// 	}
							
						// }

						if(!self.$parent.Form.ledgerDataModel.productVariants[0].secondaryUnitId){
							self.$parent.Form.ledgerDataModel.productVariants[0].secondaryUnitId = productData.productVariants[0].secondaryUnitId;
							self.$parent.Form.ledgerDataModel.productVariants[0].secondaryUnitName = productData.productVariants[0].secondaryUnitName;
							self.$parent.Form.ledgerDataModel.productVariants[0].secondaryUnitPackQuantity = productData.productVariants[0].secondaryUnitPackQuantity;

							if(!self.$parent.Form.ledgerDataModel.productVariants[0].packQuantity || (self.$parent.Form.ledgerDataModel.productVariants[0].packQuantity != productData.productVariants[0].packQuantity)){
								self.$parent.Form.ledgerDataModel.productVariants[0].packQuantity = productData.productVariants[0].packQuantity;
							}
						}
			          }
			          else{
			          	self.fn_bindData(productData);
			          }
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},

		fn_refreshUnits: function (variants, baseTransactionListId) {
			let productVariants = this.$parent.Form.ledgerDataModel.productVariants;
      		if(variants.length != productVariants.length){

				for(var j in variants){
				   	var shared = false;

				   	for (var k in productVariants){
				   		if (productVariants[k].productVariantId == variants[j].productVariantId) {
				           shared = true;
				           break;
				       }
				   	}
				       
				   	if(!shared){
				   		let variantObj = {};

			          	variantObj.unitName = variants[j].unitName;
			          	variantObj.unitId = variants[j].unitId;
			          	variantObj.primaryUnitId = variants[j].variantBaseUnitId;
			          	variantObj.packQuantity = variants[j].packQuantity;
			          	variantObj.productId = variants[j].productId;
			          	variantObj.productVariantId = variants[j].productVariantId;

			          	variantObj.qty = null;

			          	//adding bill qty 0 while ading variant in case of edit
			          	if(this.$parent.Form.transactionData.transactionListId == transactionTypes.purchaseReturn.id && baseTransactionListId == transactionTypes.purchaseInvoice.id){
			          		variantObj.billQty = 0;
			          	}

			          	productVariants.splice(j, 0, variantObj);
				   	} 
				}

			}
		},

		fn_bindData: function (productData) {
			this.$parent.Form.ledgerDataModel.productVariants = JSON.parse(JSON.stringify(productData.productVariants));

			self = this;
			this.$parent.Form.ledgerDataModel.productVariants.forEach( function(item) {
				item.primaryUnitId = item.variantBaseUnitId;
				item.primaryUnitName = item.unitName;

				self.$set(item, 'qty', 1);
				
				//setting pack quantity 1 in case of null or base variant
				!item.packQuantity ? item.packQuantity = 1 : '';

				if(item.secondaryUnitId && !item.selectedUnit){
					item.selectedUnit = {};
					item.selectedUnit.itemId = item.unitId;
					item.selectedUnit.itemName = item.unitName;
				}
			});

			this.$parent.Form.ledgerDataModel.mrp = productData.mrp;
			this.$parent.Form.ledgerDataModel.rate = productData.purchaseRate;

			
			// this.$parent.Form.ledgerDataModel.taxValue = productData.taxValue;
			// this.$parent.Form.ledgerDataModel.cessValue = productData.cessValue;
			this.$parent.Form.ledgerDataModel.hsnCode = productData.hsnCode;

			if(productData && productData.purchaseTaxCategoryId){
				this.$parent.Form.ledgerDataModel.taxCategoryId = productData.purchaseTaxCategoryId;
				this.$parent.Form.ledgerDataModel.taxCategoryName = productData.purchaseTaxCategoryName;
				this.$parent.Form.ledgerDataModel.taxValue = productData.purchaseTaxValue;
				this.$parent.Form.ledgerDataModel.cessValue = productData.purchaseCessValue;
				this.$parent.Form.ledgerDataModel.isCessApplicable = productData.purchaseIsCessApplicable;

				//saving default tax value for draft
				this.$parent.Form.ledgerDataModel.defaultTaxCategoryId = productData.purchaseTaxCategoryId;
				this.$parent.Form.ledgerDataModel.defaultTaxValue = productData.purchaseTaxValue;
				this.$parent.Form.ledgerDataModel.defaultCessValue = productData.purchaseCessValue;
			}
			else{
				this.$parent.Form.ledgerDataModel.taxCategoryId = productData.taxCategoryId;
				this.$parent.Form.ledgerDataModel.taxCategoryName = productData.taxCategoryName;
				this.$parent.Form.ledgerDataModel.taxValue = productData.taxValue;
				this.$parent.Form.ledgerDataModel.cessValue = productData.cessValue;
				this.$parent.Form.ledgerDataModel.isCessApplicable = productData.isCessApplicable;

				//saving default tax value for draft
				this.$parent.Form.ledgerDataModel.defaultTaxCategoryId = productData.taxCategoryId;
				this.$parent.Form.ledgerDataModel.defaultTaxValue = productData.taxValue;
				this.$parent.Form.ledgerDataModel.defaultCessValue = productData.cessValue;
			}

			if(productData.groupTypeId==101){
				this.fn_getBatches(productData.productId);
			}

			// this.$parent.Form.ledgerDataModel.taxCategoryId = productData.taxCategoryId;
			// this.$parent.Form.ledgerDataModel.taxCategoryName = productData.taxCategoryName;
			// this.$parent.Form.ledgerDataModel.defaultTaxCategoryId = productData.taxCategoryId;
			// this.$parent.Form.ledgerDataModel.isCessApplicable = productData.isCessApplicable;

			// //saving default tax value for draft
			// this.$parent.Form.ledgerDataModel.defaultTaxValue = productData.taxValue;
			// this.$parent.Form.ledgerDataModel.defaultCessValue = productData.cessValue;
		},

		
		fn_checkValidations: function(doneAndNew){
			this.disableBtn = true;
			let quantityFilled = false;
			
			this.$validator.validateAll('fields').then((result) => {
		        if (result) {
		        	this.$parent.Form.ledgerDataModel.netAmount = this.netAmount;
				

		        	if(this.netAmount<0){
		        		this.showToast("Amount cannot be negative");
		        		this.disableBtn = false;
		        	}
		        	else{
		        		this.saveItem(this.$parent.Form.ledgerDataModel, doneAndNew);
		        	}
		        }
		        else{
		        	this.disableBtn = false;
		        }
		    });
		},

		fn_checkPercentage: function (item) {
			!item.percentage ? item.value = null : '';
		},

		fn_computeValues: function () {
			// let grossAmount = 0;
			// let grossAmountAsPerMRP = 0;

			// let netValue = 0;
			// let finalAmount = 0;

			let self = this;

			//Calculating gross amount
			// productData.productVariants.forEach(function (item) {
				// let packQty = 1;
				// let qty = 1;
				// let rate = productData.rate;

				// item.packQuantity ? packQty = item.packQuantity : '';

				// item.qty ? qty = item.qty : '';

				//calculation as per rate
				// if(!qty || !rate)
				// 	grossAmount += 0;
				// else{
				// 	grossAmount += qty * packQty * rate;
				// }

				//calculation as per mrp
				// let mrp = productData.mrp;
				// if(!qty || !mrp)
				// 	grossAmountAsPerMRP += 0;
				// else{
				// 	grossAmountAsPerMRP += qty * packQty * mrp;
				// }
			// })

			// productData.grossAmount = this.roundUpto2Decimals(grossAmount);
			// productData.grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP);

			// grossAmount = this.roundUpto2Decimals(grossAmount);
			// grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP);
			// netValue = this.roundUpto2Decimals(grossAmount);

			//calculating addons
			// let mrp = productData.mrp ? productData.mrp : 0;
			// let addOnsTotalValue = 0;

			// let itemTaxAmount = 0;
			// let addibleTax = 0;

			// productData.addOnsItems.forEach(function (item) {

			// 	let applicableAmount = 0;
			// 	let addOnsValue = 0;

			// 	//on net value
			// 	if(item.appliedOn == 0){
			// 		applicableAmount = netValue;
			// 	}//value of goods
			// 	else if(item.appliedOn == 1){
			// 		applicableAmount = grossAmount;
			// 	}//on mrp
			// 	else{
			// 		applicableAmount = grossAmountAsPerMRP;
			// 	}

			// 	//Caculating addOns except gst's
			// 	if(!item.isGst){
			// 		//of value or percentage
			// 		if(item.mode){//value
			// 			addOnsValue = item.value;
			// 		}
			// 		else{//percentage
			// 			if(item.percentage){
			// 				addOnsValue = (applicableAmount*item.percentage)/100;
			// 				item.value = self.roundUpto2Decimals(addOnsValue);
			// 			}
			// 			else if(item.value){
			// 				addOnsValue = item.value;
			// 			}
			// 		}
			// 	}
				

			// 	addOnsValue = self.roundUpto2Decimals(addOnsValue);

			// 	//Final calculation
			// 	if(item.adjustInTotal){
			// 		if(item.nature==0){
			// 			netValue = netValue + addOnsValue;
			// 		}
			// 		else{
			// 			netValue = netValue - addOnsValue;
			// 		}
			// 	}

			// });


			//Tax will only affect net amount in case of exclusive tax where this.$parent.Form.taxMode == 1

			let itemTaxAmount = 0;
			let addibleTax = 0;
			let itemCessAmount = 0;
            let netValue = this.$parent.Form.ledgerDataModel.amount;
            let taxValue = this.$parent.Form.ledgerDataModel.taxValue;
            let cessValue = this.$parent.Form.ledgerDataModel.cessValue;
			if(this.$parent.Form.taxMode){

				let taxAmountInclusive = null;

				// if(productData.taxValue && self.$parent.Form.taxMode==2){
				// 	taxAmountInclusive = (netValue * productData.taxValue)/(100+productData.taxValue);
				// }
				

				this.$parent.Form.gstAddOns.forEach(function (item) {

					if(taxValue){
						let gstCategoriesLength = self.$parent.Form.gstAddOns.length;

						let percentage = taxValue / gstCategoriesLength;

						// item.percentage = percentage;

						//exclusive tax
						if(self.$parent.Form.taxMode==1){
							let taxAmount = (netValue * percentage)/100;
							let value = self.roundUpto2Decimals(taxAmount);
							addibleTax += value ? value : 0;
							itemTaxAmount += value;
						}
						//inclusive tax
						else if(self.$parent.Form.taxMode==2){
							// let taxAmount = (netValue * item.percentage)/(100+item.percentage);
							let value = self.roundUpto2Decimals(taxAmountInclusive/gstCategoriesLength);
							itemTaxAmount += value;
						}
					}

				});

				//Calculation of cess

				if(this.Form.ledgerDataModel.isCessApplicable){

					this.$parent.Form.cessAddOns.percentage = cessValue;

					//exclusive tax
					if(self.$parent.Form.taxMode==1){
						// let cessAmount = (netValue * this.$parent.Form.cessAddOns.percentage)/100;
						// this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmount);
						// addibleTax += this.$parent.Form.cessAddOns.value;
						if(cessValue!=null){
							let cessAmount = (netValue * this.$parent.Form.cessAddOns.percentage)/100;
							this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmount);
							addibleTax += this.$parent.Form.cessAddOns.value ? this.$parent.Form.cessAddOns.value : 0;	
							itemCessAmount = this.$parent.Form.cessAddOns.value;
						}
						else{
							this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmount);
							addibleTax += cessAmount ? cessAmount : 0;	
							itemCessAmount = cessAmount;
						}
						
					}
					//inclusive tax
					else if(self.$parent.Form.taxMode==2){

						if(cessValue!=null){
							let cessAmountInclusive = (netValue * cessValue)/(100+cessValue);
							this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmountInclusive);
							itemCessAmount = this.$parent.Form.cessAddOns.value;
						}
						else{
							this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmount);
							itemCessAmount = cessAmount;
						}

					}

				}
			}

			taxAmount = self.roundUpto2Decimals(itemTaxAmount);
			cessAmount = self.roundUpto2Decimals(itemCessAmount);

			if(cessValue==null && itemCessAmount===''){
				cessAmount = null;
			}

			//Taxable amount is net value after deduction of addons on which tax(gst) will apply
			//taxable value in case of exclusive tax

			let taxableValue = this.roundUpto2Decimals(netValue);
			// if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
			// 	productData.taxableValue = this.roundUpto2Decimals(netValue);
			// }
			// else{
			// 	productData.taxableValue = this.roundUpto2Decimals(netValue + addibleTax);
			// }
			

			//Gross amount in case of inclusive tax
			if(self.$parent.Form.taxMode==2){
				//taxable value in case of inclusive tax
				taxableValue = this.roundUpto2Decimals(netValue - itemTaxAmount - itemCessAmount);
			}

			//calculating net amount after default tax
			return this.roundUpto2Decimals(netValue + addibleTax);
		},
		fn_removeBatch: function(batchIndex){
			this.$parent.Form.ledgerDataModel.batches.splice(batchIndex, 1);
			let totalQty = 0;
			for(let i=0; i<this.$parent.Form.ledgerDataModel.batches.length; i++){
				totalQty = totalQty + Number(this.$parent.Form.ledgerDataModel.batches[i].productQty);
			}
			this.$parent.Form.ledgerDataModel.productVariants[0].qty = totalQty ? totalQty : null;
		},

		fn_unitChange: function(value, item){
			if(!this.dialogJustOpen){
				this.$set(item, 'itemId', value.itemId);
				this.$set(item, 'itemName', value.itemName);
				let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
				if(currentItemId != value.itemId){
					if(value.itemId == item.secondaryUnitId){
						this.$parent.Form.ledgerDataModel.rate = (this.$parent.Form.ledgerDataModel.rate * item.packQuantity) / item.secondaryUnitPackQuantity;
						// this.$parent.Form.ledgerDataModel.rate = this.roundUpto2Decimals(this.$parent.Form.ledgerDataModel.rate / item.secondaryUnitPackQuantity);
					}
					else{
						this.$parent.Form.ledgerDataModel.rate = (this.$parent.Form.ledgerDataModel.rate * item.secondaryUnitPackQuantity) / item.packQuantity;
						// this.$parent.Form.ledgerDataModel.rate = this.roundUpto2Decimals(this.$parent.Form.ledgerDataModel.rate * item.secondaryUnitPackQuantity);
					}	
					// this.tempRate = this.$parent.Form.ledgerDataModel.rate;
					this.$parent.Form.ledgerDataModel.rate = this.roundUpto2Decimals(this.$parent.Form.ledgerDataModel.rate); 
				
					if(item.billQty != undefined){
						this.fn_checkAndUpdateBillQty(value, item);
					}
				}

				this.fn_checkInput(item);
			}
		},

		fn_checkAndUpdateBillQty: function(value, item){
			if(item.secondaryUnitId){
				if(value.itemId == item.secondaryUnitId){
					item.billQty = Math.round(this.roundUpto2Decimals((item.billQty * item.secondaryUnitPackQuantity) / item.packQuantity));
					if(this.$parent.Form.ledgerDataModel.batches && this.$parent.Form.ledgerDataModel.batches.length){
						for(let i=0; i<this.$parent.Form.ledgerDataModel.batches.length; i++){
							if(this.$parent.Form.ledgerDataModel.batches[i].billQty!=undefined){
								this.$parent.Form.ledgerDataModel.batches[i].billQty = Math.round(this.roundUpto2Decimals((this.$parent.Form.ledgerDataModel.batches[i].billQty * item.secondaryUnitPackQuantity) / item.packQuantity));
							}
						}
					}
				}
				else{
					item.billQty = this.roundUpto2Decimals((item.billQty * item.packQuantity) / item.secondaryUnitPackQuantity);
					if(this.$parent.Form.ledgerDataModel.batches && this.$parent.Form.ledgerDataModel.batches.length){
						for(let i=0; i<this.$parent.Form.ledgerDataModel.batches.length; i++){
							if(this.$parent.Form.ledgerDataModel.batches[i].billQty!=undefined){
								this.$parent.Form.ledgerDataModel.batches[i].billQty = this.roundUpto2Decimals((this.$parent.Form.ledgerDataModel.batches[i].billQty * item.packQuantity) / item.secondaryUnitPackQuantity);
							}
						}
					}
				}
			}
		},

		fn_changeBatchType: function(val){
			if(val==2 && this.$parent.Form.ledgerDataModel.batches && this.$parent.Form.ledgerDataModel.batches.length){
				if(this.$parent.Form.ledgerDataModel.productVariants[0].selectedUnit){
					this.$parent.Form.ledgerDataModel.productVariants[0].selectedUnit = {"itemId":this.$parent.Form.ledgerDataModel.productVariants[0].primaryUnitId, "itemName":this.$parent.Form.ledgerDataModel.productVariants[0].primaryUnitName}
				}
			}
		}

		// fn_assignTempValue: function(val){
		// 	this.tempRate = val;
		// }
	},
	computed:{
		netAmount: function () {
			return this.fn_computeValues(this.$parent.Form.ledgerDataModel);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/credit_debit_note/dialogs/dialog_ledger.vue